<div class="flex-direction-column gap-5">
    @if (label) {
      <span class="label" [style.color]="colorLabel ?? ''">{{label}}</span>
    }

    @if (carregandoInfo) {
      <div class="skeleton" [style.width]="widthFormField" [style.height]="heightFormField"></div>
    }@else{
      <mat-form-field
        appearance="outline"
        [style.width]="widthFormField"
        [style.height]="heightFormField"
        [hideRequiredMarker]="true"
        [style.background-color]="backgroundColor ?? 'rgba(221, 188, 255, 0.1)'"
      >
        @if (iconPrefix) {
          <mat-icon [style.color]="iconColor ?? 'black'" matPrefix>{{iconPrefix}}</mat-icon>
        }

        <mat-select [(ngModel)]="itensSelecionado" [disabled]="disabled" [placeholder]="placeholder" (ngModelChange)="onChange()" multiple [compareWith]="compararListas" [style.font-size]="font">
          @if (habilitarBusca) {
            <ngx-mat-select-search
              [formControl]="filtroControl"
              placeholderLabel="Pesquisar"
              noEntriesFoundLabel="Nenhum resultado encontrado">
            </ngx-mat-select-search>
          }
          @for (item of listaInput; track item) {
            <mat-option [matTooltip]="item[campo]" matTooltipPosition="right" [value]="item" [disabled]="item['disabled']">
              @if (campo) {
                <span [style.font-size]="font">{{ item[campo] }}</span>
                @if (subCampo) {
                  <span [style.font-size]="font"> - {{ item[subCampo] }}</span>
                }
              } @else {
                <span [style.font-size]="font">{{ item }}</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
</div>
